export default __webpack_public_path__ + "static/media/img_main_mockup.5872c28b.png";